// extracted by mini-css-extract-plugin
export var subtitle = "_ag-2";
export var title = "_ag-0";
export var titleNoWrap = "_ag-1";